import { render, staticRenderFns } from "./TopicOriginForm.vue?vue&type=template&id=ab230a20&scoped=true"
import script from "./TopicOriginForm.vue?vue&type=script&lang=js"
export * from "./TopicOriginForm.vue?vue&type=script&lang=js"
import style0 from "./TopicOriginForm.vue?vue&type=style&index=0&id=ab230a20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab230a20",
  null
  
)

export default component.exports